import actions from './actions';
import initialState from '../initialState';

export const templatesReducer = (state = initialState.templates, action) => {
    switch (action.type) {
        case actions.EDIT_TEMPLATE_MODAL:
            return {
                ...state,
                editTemplateModal: action.state.editTemplateModal,
            };
        case actions.EDIT_NOTES_MODAL:
            return { ...state, editNotesModal: action.state.editNotesModal };
        case actions.EDIT_NAME_MODAL:
            return { ...state, editNameModal: action.state.editNameModal };
        default:
            return { ...state };
    }
};

export default templatesReducer;
